import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import IOSSwitch from "../../components/SwitchButton";
import FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment";
import { requestUpdateUserStatus } from "../../redux/actions/tabManagementActionCreators";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({
  rows,
  head,
  handeleUserDetails,
  page,
  handlePage,
  totalPages,
  searchText,
  enterprise,
  status,
  type,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const getAccountTypeLabel = (accountType) => {
    if (accountType === "enterprise") {
      return "Enterprise";
    }
    if (accountType === "free") {
      return "Free";
    }
    return t(accountType);
  };

  return (
    <div>
      <TableContainer
        component={Paper}
        className="scrollhost"
        sx={{
          width: "100%",
          height: "550px",
          overflowY: "scroll",
          "&.MuiTableContainer-root": {
            borderRadius: "0px",
            boxShadow: "none",
          },
        }}
      >
        <Table
          stickyHeader
          aria-label="customized table"
          sx={{
            "& .MuiTableRow-root:hover": {
              backgroundColor: "#DDF6F0",
              cursor: "pointer",
            },
          }}
        >
          <TableHead>
            <TableRow>
              {head.map((el, i) => (
                <StyledTableCell key={i} align={el.align} width={el.width}>
                  {el.value}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.map((row) => (
              <StyledTableRow
                key={row?.id}
                onClick={() => handeleUserDetails(row)}
              >
                <StyledTableCell align="left">
                  <Typography variant="title9">{row?.username}</Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {" "}
                  <Typography variant="title9">{row?.email}</Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {" "}
                  <Typography variant="title9">
                    {getAccountTypeLabel(row?.type)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <Typography variant="title9">
                    {moment(row?.creation_date, "DD/MM/YYYY HH:mm:ss").format(
                      "DD-MM-YYYY"
                    )}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {row?.type === "enterprise" && (
                    <FormControlLabel
                      onClick={(event) => event.stopPropagation()}
                      control={
                        <IOSSwitch
                          sx={{ margin: "8px -8px 4px 8px" }}
                          color="success"
                          checked={row?.status}
                          onChange={(event) => {
                            dispatch(
                              requestUpdateUserStatus(
                                page,
                                searchText,
                                enterprise,
                                status,
                                type,
                                row?.public_id,
                                event.target.checked
                              )
                            );
                          }}
                        />
                      }
                    />
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack spacing={2} justifyContent="right" direction="row">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </div>
  );
}
